import { ReactNode } from 'react'

const AddressDisplay = ({
  children,
  className = '',
}: {
  children: ReactNode
  className?: string
}) => {
  return (
    <div
      className={`whitespace-nowrap rounded border border-th-bkg-3 bg-th-bkg-2 px-1 py-0.5 ${className}`}
    >
      {children}
    </div>
  )
}

export default AddressDisplay
